import(/* webpackMode: "eager", webpackExports: ["FactionAvatar"] */ "/app/apps/web/src/components/common/image/faction-avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerAvatar"] */ "/app/apps/web/src/components/common/image/player-avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FactionFeudSection"] */ "/app/apps/web/src/components/leaderboard/faction-feud-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FactionLeaderboard"] */ "/app/apps/web/src/components/leaderboard/faction-leaderboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeaderboardNavigationMenu"] */ "/app/apps/web/src/components/leaderboard/navigation-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/leaderboard/top3-carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.28.5_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__react@19.2.6_sass@1.79.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.28.5_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__react@19.2.6_sass@1.79.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/icons/icomoon.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-bronze.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-gold.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-silver.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/subscription/add_club_coin_icon.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/subscription/club_coin_icon.webp");
